<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { createSelectOptionsFrom } from '@/helpers/enumHelper';
import { SelectOption } from '@/classes/SelectOption';

@Component
export default class BooleansMixin extends Vue {
  protected stepPath: string = 'generic';

  protected getEnumOptions(
    enumParam: any,
    translationPath?: string
  ): SelectOption[] {
    return createSelectOptionsFrom(enumParam).map((opt: SelectOption) => {
      opt.label = this.$t(
        `${translationPath || this.stepPath}.${opt.label}`
      ).toString();
      return opt;
    });
  }
}
</script>

<style></style>
